export const ActionTypes = {
  ITINERARY_ACCEPT: 'ITINERARY_ACCEPT',
  ITINERARY_ACCEPT_SUCCESS: 'ITINERARY_ACCEPT_RECEIVE',
  ITINERARY_ACCEPT_ERROR: 'ITINERARY_ACCEPT_ERROR',
  ITINERARY_GET_REQUEST: 'ITINERARY_GET_REQUEST',
  ITINERARY_GET_RECEIVE: 'ITINERARY_GET_RECEIVE',
  ITINERARY_INTL_GET_RECEIVE: 'ITINERARY_INTL_GET_RECEIVE',
  ITINERARY_GET_ERROR: 'ITINERARY_GET_ERROR',
  ITINERARY_REQUEST_CHANGES_REQUEST: 'ITINERARY_REQUEST_CHANGES_REQUEST',
  ITINERARY_REQUEST_CHANGES_RESPONSE: 'ITINERARY_REQUEST_CHANGES_RESPONSE',
  ITINERARY_REQUEST_CHANGES_ERROR: 'ITINERARY_REQUEST_CHANGES_ERROR',
  SEGMENT_SELECT: 'SEGMENT_SELECT',
  SEGMENT_DESELECT: 'SEGMENT_DESELECT',
  OPTION_SELECT: 'OPTION_SELECT',
  OPTION_SELECT_WITH_RATE: 'OPTION_SELECT_WITH_RATE',
  TOGGLE_CONFIRM_DIALOG: 'TOGGLE_CONFIRM_DIALOG',
  USER_NOTE_CHANGE: 'USER_NOTE_CHANGE',
  SEGMENT_DETAILS_UPDATE: 'SEGMENT_DETAILS_UPDATE',
  RATE_SELECT: 'RATE_SELECT',
  RATE_CLEAR: 'RATE_CLEAR',
  RECORD_METRIC: 'RECORD_METRIC',
  COMBINATION_INIT: 'COMBINATION_INIT',
  UPDATE_SELECTEDCOMBINATIONS:'UPDATE_SELECTEDCOMBINATIONS',
  UPDATE_RECOMMENDED_HOTEL_ITEM:'UPDATE_RECOMMENDED_HOTEL_ITEM',
  UPDATE_RECOMMENDED_CAR_ITEM:'UPDATE_RECOMMENDED_CAR_ITEM'
};
